try {
    require("@babel/polyfill");
} catch (e) {}

import Backbone from "backbone";
import {FloorPlanCollection} from "./src/data";
import {fetch} from "./src/utils/ajax";
import {customEvent} from "./src/utils/events";
import {FloorPlanAppView} from "./src/views";
import {MainView} from "./src/views/main";
import {MapView} from "./src/views/map";
import {Router} from "./src/router";

let smallQuery = window.matchMedia("(max-width: 767px)");
let mediumQuery = window.matchMedia("(max-width: 1199px)");

let dataPromise = fetch(window.api_key);
dataPromise.then(function(data) {
    let config = window.futureFloorPlansConfig || {};

    let apartmentTypeSettings = {
        apartmentType: config.apartmentType || "Apartment",
        apartmentTypeLong: config.apartmentTypeLong || "Apartment Homes"
    };

    let fpCollectionConfig = _.extend(
        {availableString: ""},
        config.collection || {},
        {parse: true}
    );

    let fc = new FloorPlanCollection(data, fpCollectionConfig);
    fc._buildChecklists();
    let fp = fc.getActive();
    let unit = fc.getActiveUnit();

    if (fp) {
        // preload site map images
        let maps = fp.get("community").map.filter(map => map.image);
        _.each(maps, function(map) {
            let image = new Image();
            image.src = map.image;
        });
    }

    let r = new Router();

    let base = {collection: fc, floorPlan: fp, unit: unit};
    let mainViewConfig = _.extend(
        {},
        apartmentTypeSettings,
        config.mainView || {},
        base
    );
    let v = new MainView(mainViewConfig);

    let mapViewConfig = _.extend(
        {},
        apartmentTypeSettings,
        config.mapView || {},
        base
    );

    let m = new MapView(mapViewConfig);

    let appViewConfig = _.extend(
        {},
        apartmentTypeSettings,
        config.appView || {},
        {collection: fc, mainView: v, mapView: m}
    );
    let a = new FloorPlanAppView(appViewConfig);
    a.render();

    let queryListener = function() {
        let renderSize = "lg";
        if (smallQuery.matches) {
            renderSize = "sm";
        } else if (mediumQuery.matches) {
            renderSize = "md";
        }

        a.setRenderSize(renderSize);
        a.render();
    };
    queryListener();
    smallQuery.addListener(queryListener);
    mediumQuery.addListener(queryListener);

    r.on("route", function(name, args) {
        // Toggle the primary app view between displaying the
        // map and the main view.
        let [slug, number] = args;
        let fp = null;
        let unit = null;
        if (slug) {
            if (/^[\d]+$/.test(slug)) {
                fp = fc.findWhere({id: parseInt(slug, 10)});

                if (!fp) {
                    fp = fc.findWhere({slug});
                }
            } else {
                fp = fc.findWhere({slug});
            }
            if (fp) {
                fc.setActive(fp.get("id"));
                if (number && fp.get("units").length) {
                    unit = fp.get("units").findWhere({number});

                    if (!unit) {
                        unit = fp.get("units").findWhere({
                            number: number.replaceAll("-", " ")
                        });
                    }

                    if (unit) {
                        fc.setActiveUnit(unit.get("id"));
                    }
                }
            }
        } else {
            fp = fc.getActive();
            unit = fc.getActiveUnit();
            let routeStr = "";
            if (fp) {
                routeStr = fp.get("slug");
                if (unit) {
                    routeStr += `/${unit.getNumberSlug()}`;
                }
                r.navigate(routeStr, {replace: true});
            }
        }

        if (name === "mapRoute") {
            a.setView("map", false);
            m.setFilter(!!(fp && unit));
        } else {
            a.setView("main", false);
        }
        a.render();
    });

    fc.on("nav", function(view, args) {
        // We need to change between map and main views
        let [fp, unit] = args;
        let routeStr = "";
        if (view === "map") {
            routeStr = "map";
            if (fp && unit) {
                routeStr = `${routeStr}/${fp.get("slug")}/${unit.getNumberSlug()}`;
            }
        } else {
            if (!fp) {
                fp = fc.getActive();
                unit = fc.getActiveUnit();
            }

            if (fp) {
                routeStr = fp.get("slug");
            }
            if (unit) {
                routeStr = `${routeStr}/${unit.getNumberSlug()}`;
            }
        }
        r.navigate(routeStr);
    });

    fc.on("nav:map", function(fp, unit) {
        m.setFilter(!!(fp && unit));
        a.setView("map", false);
        a.render();
    });

    fc.on("select:fp", function() {
        // A floor plan has been selected through user interaction
        let fp = fc.getActive();
        let unit = fc.getActiveUnit();

        if (fp) {
            let routeStr = fp.get("slug");
            if (unit) {
                routeStr += "/" + unit.getNumberSlug();
            }
            r.navigate(routeStr);
        }
        a.setFloorPlan(fp);
        a.setUnit(fc.getActiveUnit());
        a.render();
    });
    fc.on("select:unit", function() {
        // A unit has been selected through user interaction
        let fp = fc.getActive();
        let unit = fc.getActiveUnit();

        if (fp && unit) {
            r.navigate(`${fp.get("slug")}/${unit.getNumberSlug()}`);
        }
        a.setUnit(unit);
        a.render();
    });
    fc.on("filter", function() {
        let floorPlan = fc.getActive();
        let visible = fc.groups();
        let isVisible = false;
        let first = null;

        visible.forEach(function(fps) {
            if (!first && fps.length) {
                first = fps[0];
            }

            for (let i = 0; i < fps.length; i++) {
                 if (floorPlan.get("id") === fps[i].get("id")) {
                     isVisible = true;
                     break;
                 }
            }
        });

        if (isVisible) {
            let unit = fc.getActiveUnit();
            a.setUnit(unit);
            a.render();
        } else {
            let fp = first ? first.get("id") : null;
            fc.setActive(fp);
        }
    });

    Backbone.history.start();

    let elem = document.getElementById("floorplans_main");
    elem.appendChild(a.render().el);

    let loadEvent = customEvent("fp-load");
    window.dispatchEvent(loadEvent);
});
